import React, { useState } from 'react';
import { advisors } from '../data/advisors';

const AdvisorsSection = () => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const selectedAdvisor = advisors[selectedIndex];

  return (
    <section id="advisors" className="section advisors-section">
      <h2 className="section-title">Select Your Sales Advisor</h2>
      <p style={{textAlign: 'center', marginBottom: '40px', color: '#666'}}>
        Click on an advisor below to view their details and contact them directly.
      </p>
      
      <div className="advisor-dashboard">
        <div className="advisor-spotlight">
          <img src={selectedAdvisor.img} alt={selectedAdvisor.name} className="spotlight-img" />
          <div className="spotlight-info">
            <h3>{selectedAdvisor.name}</h3>
            <div className="spotlight-role">{selectedAdvisor.role}</div>
            <div className="spotlight-actions">
              <a 
                href={`https://wa.me/${selectedAdvisor.phone}?text=Hi ${selectedAdvisor.name}, I found you on the Perodua website.`}
                className="cta-btn whatsapp"
                target="_blank"
                rel="noopener noreferrer"
              >
                WhatsApp Me
              </a>
              <a href={`tel:${selectedAdvisor.phone}`} className="cta-btn" style={{background: 'var(--secondary)'}}>
                Call Now
              </a>
            </div>
          </div>
        </div>

        <div className="advisor-selection-grid">
          {advisors.map((advisor, index) => (
            <div
              key={index}
              className={`advisor-thumbnail ${index === selectedIndex ? 'active' : ''}`}
              onClick={() => setSelectedIndex(index)}
            >
              <div className="thumb-img" style={{backgroundImage: `url('${advisor.img}')`}}></div>
              <div className="thumb-name">{advisor.name}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AdvisorsSection;
